import { S as Swiper } from './swiper-core-CZxReCTq.js';
import { N as Navigation } from './navigation-x_V9jDoE.js';
import { P as Pagination } from './pagination-Bm-_wMJZ.js';

class FeaturedCollection extends HTMLElement {
  connectedCallback() {
    this.initSwiper();
  }

  /**
   * Get navigation configuration for swiper
   * @param {HTMLElement} swiperEl - The swiper container element
   * @returns {Object|boolean} Navigation configuration or false
   */
  getNavigationConfig(swiperEl) {
    const showNavigation = this.dataset.showNavigation === 'true';

    if (!showNavigation) return false;

    // Separate desktop and mobile navigation
    let desktopNext = null,
      desktopPrev = null;
    let mobileNext = null,
      mobilePrev = null;

    // Desktop navigation is inside the swiper container
    const desktopNav = swiperEl.querySelector('.max-md\\:hidden');
    if (desktopNav) {
      desktopNext = desktopNav.querySelector('.swiper-button-next');
      desktopPrev = desktopNav.querySelector('.swiper-button-prev');
    }

    // Mobile navigation is in the md:hidden container
    const mobileContainer = this.querySelector('.md\\:hidden');
    if (mobileContainer) {
      mobileNext = mobileContainer.querySelector('.swiper-button-next');
      mobilePrev = mobileContainer.querySelector('.swiper-button-prev');
    }

    // Return both sets of navigation for Swiper to use
    const nextElements = [desktopNext, mobileNext].filter(Boolean);
    const prevElements = [desktopPrev, mobilePrev].filter(Boolean);

    if (nextElements.length === 0 || prevElements.length === 0) return false;

    return {
      nextEl: nextElements,
      prevEl: prevElements,
      disabledClass: 'swiper-button-disabled',
    };
  }

  /**
   * Get pagination configuration for swiper
   * @param {HTMLElement} swiperEl - The swiper container element
   * @returns {Object|boolean} Pagination configuration or false
   */
  getPaginationConfig(swiperEl) {
    const showPagination = this.dataset.showPagination === 'true';

    if (!showPagination) return false;

    return {
      el: swiperEl ? swiperEl.querySelector('.swiper-pagination') : null,
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 3,
    };
  }

  /**
   * Initialize the swiper instance
   */
  initSwiper() {
    const swiperEl = this.querySelector('.swiper--featured');
    if (!swiperEl) {
      console.warn('Featured Collection: Swiper element not found');
      return;
    }

    // Get settings from data attributes
    const loop = this.dataset.loop === 'true';
    const navigation = this.getNavigationConfig(swiperEl);
    const pagination = this.getPaginationConfig(swiperEl);

    const swiperOptions = {
      modules: [Navigation, Pagination],
      spaceBetween: 16,
      slidesPerView: 1.3,
      loop,
      watchOverflow: true,
      pagination,
      navigation,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3.2,
        },
        1140: {
          slidesPerView: 4.1,
        },
      },
    };

    // Initialize swiper
    const swiperInstance = new Swiper(swiperEl, swiperOptions);

    // Store reference for potential external access
    this.swiper = swiperInstance;
  }

  /**
   * Destroy swiper instance when element is disconnected
   */
  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('featured-collection', FeaturedCollection);
